import { Button, Form, Input, message, Modal, Select} from 'antd';
import {useFetch, useFormLayout} from '@utils'
import React, { useContext, useEffect, useState} from 'react';
import { appContext } from '../../../../AppContext';
const { Option } = Select;

export default function AddTodoModal({
    isModalVisible, 
    setIsModalVisible, 
    characterId, 
    refresh
}){

    const [form] = Form.useForm()
    const layout = useFormLayout();
    const [doFetch, FetchOptions] = useFetch();
    const [appState] = useContext(appContext);
    const [sl, setSl] = useState([]);

    useEffect(() => {
        doFetch(`/api/v2/story/GetSL`)
            .then((response) => slLoaded(response.isSuccess, response.result))

        function slLoaded(isSuccess, result) {
            if(isSuccess) {
                setSl(result)
            }
        }

    }, // eslint-disable-next-line
    [])

    const slOptions = sl?.map(_ => {
    return (<Option 
        value={_.id} 
        key={_.id}
    >
        {_.name}
    </Option>)
    })

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    function onFinish(values) {

        const url = `/api/characterTodo`;
        const body = {
            characterId: characterId,
            larper: { id: values.slId},
            description: values.description
        }

        doFetch(url, FetchOptions.POST, body)
            .then((response) => onLoaded(response.isSuccess, response.result))

        function onLoaded(isSuccess, result) {
            if(isSuccess) {
                refresh()
                setIsModalVisible(false);
                return;
            } 

            message.error('Could not update');
        }
    }

    return (
            <Modal 
                title={`Add todo`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
            >
                <Form 
                        form={form}
                        {...layout}
                        name="basic"
                        layout="horizontal"
                        onFinish={onFinish}
                        >
                        <Form.Item
                            label="Description"
                            name="description"
                            rules={[{ required: true, message: "Vul een beschrijving in." }]}
                        >
                            <Input 
                                name="description" 
                                />
                        </Form.Item>

                        <Form.Item
                                    label="SL"
                                    name="slId"
                                >
                                    <Select 
                                        name="slId" 
                                        defaultValue={appState.user.id}
                                    >
                                        {slOptions}
                                    </Select>
                                </Form.Item>


                        <Form.Item >
                            <Button type="primary" htmlType="submit">
                                Add
                            </Button>
                        </Form.Item>

                    </Form>
            </Modal>
    )
}